import script from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"
export * from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"

import "./my-upload-imgs.vue?vue&type=style&index=0&id=1297c60c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1297c60c"]])

export default __exports__